import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";

import {
  offer_id,
  offer_name,
  tag_id,
  tag_name,
} from "../../../constants/index";
import { mapStates } from "../../../constants/mapRegions";
import { Context } from "../../../context/context";
import LeadService from "../../../services/leadService";
import { validLeadConvert } from "../../../services/leadValidation";
import NotificationService from "../../../services/notificationService";
import sessionTracking from "../../../services/sessionTracking";
import { userQlFlow } from "../../../services/userQLFlow";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { createCookieInHour, getCookie } from "../../../utils/cookie";

const UseStoreForm = () => {
  const state = useContext(Context);

  const { showSnackbar, changeState, updateUserQlData, showReviewStoryDrawer } =
    useContext(Context);
  const [loading, setLoading] = useState(false);

  const [displayForm, setDisplayForm] = useState("block");

  useEffect(() => {
    const dispalyInfo = getCookie("StoreLEAD").length > 0 ? "none" : "block";

    setDisplayForm(dispalyInfo);
  }, []);

  const brand = state?.vehicleBrand;
  let vehicle_id = 4;
  if (brand === "OSM") vehicle_id = 3;
  else if (brand === "piaggio") vehicle_id = 2;
  else if (brand === "mahindra") vehicle_id = 1;

  const leadIntent = "HIGH_INTENT";

  const form = useFormik({
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      name: "",
      state: "none",
      mobile: "",
      otp: "",
    },

    validate: (values) => {
      const errors = {};

      if (!values?.mobile?.toString()) {
        errors.mobile = "Mobile Number is Mandatory";
      }
      if (values?.mobile?.toString()?.length !== 10) {
        errors.mobile = "Enter a valid 10 digit Mobile Number";
      }
      if (values?.mobile && values?.mobile[0] < 5) {
        errors.mobile = "Enter Valid Mobile Number";
      }

      const ipInformation = localStorage.getItem("geoLocation")
        ? JSON.parse(localStorage.getItem("geoLocation"))
        : {};

      if (values?.mobile?.toString()?.length === 10) {
        let payload = {
          phoneNumber: values?.mobile,
          connectType: "Store form",
          type: "store_form",
          cityInfo: ipInformation?.city,
          geoInfo: ipInformation,
        };
        sendAnalytics("v2_lead_form_entered_mobile", payload, "en");

        const leadPayload = {
          name: "",
          phone: values?.mobile,
          state: mapStates[ipInformation?.countryRegion] ?? "Others",
          leadIntent: leadIntent,
          subSource: "Store form",
        };

        // param: leadpayload, analyticsPayload
        validLeadConvert(leadPayload, payload);
      }

      return errors;
    },

    onSubmit: (values) => {
      changeState(values.state);
      const payload = {
        name: values?.name,
        phone: values?.mobile,
        pan: "",
        pincode: "",
        dob: "",
        state: values?.state,
        optedExchange: "",
        vehicleSelected: brand,
        language: "",
        refNumber: "",
        leadIntent: leadIntent,
        subSource: "Store form",
        verified: state?.leadVerifiedStatus,
      };

      setLoading(true);

      const analyticsPayload = {
        vehicle_name: brand,
        vehicle_id: vehicle_id,

        tag_id: tag_id,
        tag_name: tag_name,
        offer_id: offer_id,
        offer_name: offer_name,
        phone_number: values?.mobile,
        name: values?.name,
        state: values?.state,
        button_trigger_location: "store_form",
        type: "store_form",
      };

      sendAnalytics("visit_store_button_clicked", analyticsPayload, "en");
      LeadService(payload)
        .then(() => {
          showSnackbar("We will get back to you soon!!", "success");

          setLoading(false);
          setDisplayForm("none");
          createCookieInHour("StoreLEAD", payload.phone, 10);
          NotificationService(payload);

          const sessionInfo = {
            leadUuid: response?.data?.uuid,
            newSession: false,
            formSubmitted: true,
            leadIntent: "HIGH_INTENT",
          };

          // Enable QL Lead flow
          userQlFlow(state, updateUserQlData, showReviewStoryDrawer);

          sessionTracking(sessionInfo);
        })
        .catch(() => {
          showSnackbar(
            " Oops, something went wrong. Please try again later.",
            "error"
          );
        });
    },
  });

  return {
    form,
    loading,
    displayForm,
  };
};

export default UseStoreForm;
